"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.avatar.list': 'Avatars',
    'route.avatar.create': 'Add Avatar',
    'route.avatar.edit': 'Edit Avatar',
    'route.avatar.preview': 'Preview Avatar',
};
